import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  // All your services for the dropdown
  const services = [
    { title: 'Application Development', slug: '/services/application-development' },
    { title: 'Cybersecurity Services', slug: '/services/cybersecurity-services' },
    { title: 'Web Development', slug: '/services/web-development' },
    { title: 'IT/Desktop Support', slug: '/services/it-desktop-support' },
    { title: 'Cloud Solutions', slug: '/services/cloud-solutions' },
    { title: 'IT Consultation & Auditing', slug: '/services/it-consultation-auditing' },
    // { title: 'Creative Design', slug: '/services/creative-design' },
    { title: 'Tech Training & Certification', slug: '/services/tech-training' },
    { title: 'Tech Recruitment & Talent Solutions', slug: '/services/tech-recruitment' }
  ];

  return (
    <header className="bg-gray-800 text-white sticky top-0 z-50 shadow-lg">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/logo.png" 
              alt="Plexgate Logo" 
              className="h-12 w-auto"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div 
              className="h-12 w-12 bg-gray-700 rounded-lg items-center justify-center text-2xl font-bold hidden"
              style={{ display: 'none' }}
            >
              P
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8 items-center">
            <Link 
              to="/" 
              className="text-white hover:text-blue-400 transition-colors duration-300 font-medium"
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className="text-white hover:text-blue-400 transition-colors duration-300 font-medium"
            >
              About
            </Link>
            
            {/* Services Dropdown - Desktop */}
            <div 
              className="relative"
              onMouseEnter={() => setIsServicesOpen(true)}
              onMouseLeave={() => setIsServicesOpen(false)}
            >
              <button 
                className="text-white hover:text-blue-400 transition-colors duration-300 font-medium flex items-center gap-1"
              >
                Services
                <svg 
                  className={`w-4 h-4 transition-transform ${isServicesOpen ? 'rotate-180' : ''}`}
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              {/* Dropdown Menu - with padding bridge to prevent gap */}
              {isServicesOpen && (
                <div className="absolute top-full left-0 pt-2">
                  <div className="w-80 bg-white rounded-lg shadow-2xl py-2 border border-gray-200">
                    {/* View All Services Link */}
                    <Link
                      to="/services"
                      className="block px-6 py-3 text-gray-800 hover:bg-blue-50 hover:text-blue-600 transition-colors font-semibold border-b border-gray-200"
                    >
                      View All Services →
                    </Link>
                    
                    {/* Individual Services */}
                    {services.map((service, index) => (
                      <Link
                        key={index}
                        to={service.slug}
                        className="block px-6 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors text-sm"
                      >
                        {service.title}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* <Link 
              to="/tech-training" 
              className="text-white hover:text-blue-400 transition-colors duration-300 font-medium"
            >
              Training
            </Link> */}
            {/* <Link 
              to="/recruitment" 
              className="text-white hover:text-blue-400 transition-colors duration-300 font-medium"
            >
              Recruitment
            </Link> */}
            <Link 
              to="/contact" 
              className="text-white hover:text-blue-400 transition-colors duration-300 font-medium"
            >
              Contact
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white focus:outline-none"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg
              className="w-8 h-8"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <nav className="md:hidden pb-4 space-y-2">
            <Link
              to="/"
              className="block text-white hover:text-blue-400 transition-colors py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/about"
              className="block text-white hover:text-blue-400 transition-colors py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </Link>
            
            {/* Services Dropdown - Mobile */}
            <div className="py-2">
              <button
                onClick={() => setIsServicesOpen(!isServicesOpen)}
                className="w-full text-left text-white hover:text-blue-400 transition-colors flex items-center justify-between"
              >
                Services
                <svg 
                  className={`w-4 h-4 transition-transform ${isServicesOpen ? 'rotate-180' : ''}`}
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              {/* Mobile Services Submenu */}
              {isServicesOpen && (
                <div className="pl-4 mt-2 space-y-2">
                  <Link
                    to="/services"
                    className="block text-blue-400 hover:text-blue-300 transition-colors py-2 text-sm font-semibold"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    → View All Services
                  </Link>
                  {services.map((service, index) => (
                    <Link
                      key={index}
                      to={service.slug}
                      className="block text-gray-300 hover:text-blue-400 transition-colors py-2 text-sm"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {service.title}
                    </Link>
                  ))}
                </div>
              )}
            </div>
{/* 
            <Link
              to="/tech-training"
              className="block text-white hover:text-blue-400 transition-colors py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Training
            </Link>
            <Link
              to="/recruitment"
              className="block text-white hover:text-blue-400 transition-colors py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Recruitment
            </Link> */}
            <Link
              to="/contact"
              className="block text-white hover:text-blue-400 transition-colors py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;